'use strict';

import {Component, trigger, style, transition, animate, keyframes} from "@angular/core";
import {notify, Notification} from "../../services/notify/notify";

@Component({
    selector: 'notifications',
    template: `
    <div class="notification"
        [ngClass]="notification.type"
        [@notificationVisible]="true"
        *ngFor="let notification of notifications">
        {{notification.message}}
    </div>
    `,
    animations: [
        trigger('notificationVisible', [
            transition(':enter', [
                animate(600, keyframes([
                    style({
                        opacity: '0',
                        transform: 'translateX(200%)',
                        offset: 0
                    }),
                    style({
                        opacity: 0.98,
                        transform: 'translate(0, 0) scale(1)',
                        offset: 1
                    })
                ]))
            ]),
            transition(':leave', [
                animate(200, keyframes([
                    style({
                        opacity: 0.98,
                        transform: 'translate(0, 0) scale(1)',
                        offset: 0
                    }),
                    style({
                        opacity: '0',
                        transform: 'scale(0.95) translateY(-50%)',
                        offset: 1
                    }),
                ]))
            ])
        ])
    ]
})
export class NotificationsComponent {
    notifications: Array<Notification>;

    constructor() {
        this.notifications = notify.notifications;
    }
 }



// WEBPACK FOOTER //
// ./_src/ui/elements/notifications.ts